/* Tema editorial — PAGINA DE PRODUCTO
   "Anadir al carrito" por AJAX: no saca de la ficha, avisa con un mensaje y no
   recarga la pagina. "Comprar ahora" anade y lleva al pago. La barra fija de
   movil aparece cuando el bloque de compra ya no se ve.
   Todo con salida sin JavaScript: el formulario hace su POST normal. */
(function () {
  var pag = document.querySelector('[data-producto]');
  if (!pag) return;

  var form    = pag.querySelector('form[action*="/cart/add"]');
  var cant    = pag.querySelector('[data-cantidad]');
  var acciones= pag.querySelector('[data-acciones]');
  var botones = [].slice.call(pag.querySelectorAll('[data-add]'));
  var compras = [].slice.call(pag.querySelectorAll('[data-comprar]'));
  var barra   = pag.querySelector('[data-bar]');
  var titulo  = pag.getAttribute('data-titulo') || 'Libro';

  /* ---------- cantidad ---------- */
  function valor() {
    var n = parseInt(cant && cant.value, 10);
    return (!n || n < 1) ? 1 : n;
  }
  pag.addEventListener('click', function (e) {
    var menos = e.target.closest ? e.target.closest('[data-menos]') : null;
    var mas   = e.target.closest ? e.target.closest('[data-mas]') : null;
    if (!menos && !mas) return;
    e.preventDefault();
    if (cant) { cant.value = Math.max(1, valor() + (mas ? 1 : -1)); }
  });

  /* ---------- aviso ---------- */
  var aviso = null;
  function pintaAviso(html, error) {
    if (!aviso) {
      aviso = document.createElement('div');
      aviso.className = 'pr-toast';
      aviso.setAttribute('role', 'status');
      aviso.setAttribute('aria-live', 'polite');
      document.body.appendChild(aviso);
    }
    aviso.className = 'pr-toast' + (error ? ' is-err' : '');
    aviso.innerHTML = html;
    aviso.classList.add('is-on');
    clearTimeout(aviso._t);
    aviso._t = setTimeout(function () { aviso.classList.remove('is-on'); }, 7000);
  }
  function avisoOk(n) {
    pintaAviso(
      '<span class="pr-toast__i">✓</span>' +
      '<span class="pr-toast__t"><b>Añadido al carrito</b>' + titulo + (n > 1 ? ' · ' + n + ' uds.' : '') + '</span>' +
      '<a href="/cart">Ver carrito →</a>', false);
  }
  function avisoError(msg) {
    pintaAviso('<span class="pr-toast__i">!</span><span class="pr-toast__t"><b>No se ha podido añadir</b>' +
      (msg || 'Inténtalo otra vez.') + '</span>', true);
  }

  /* ---------- añadir al carrito (sin salir de la página) ---------- */
  function datos() {
    var fd = new FormData();
    var idCampo = form ? form.querySelector('[name="id"]') : null;
    fd.append('id', idCampo ? idCampo.value : '');
    fd.append('quantity', valor());
    return fd;
  }

  function marcar(boton) {
    if (!boton) return;
    var ok = boton.getAttribute('data-label-ok') || '✓';
    var base = boton.getAttribute('data-label-add') || boton.textContent.trim();
    boton.classList.add('is-ok');
    boton.textContent = ok;
    setTimeout(function () { boton.classList.remove('is-ok'); boton.textContent = base; }, 2200);
  }

  function anadir(cb) {
    if (!form) { cb && cb(true); return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: datos()
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { avisoError(res.j && (res.j.description || res.j.message)); cb && cb(false); return; }
        avisoOk(valor());
        /* el contador de la cabecera se refresca solo */
        try { document.dispatchEvent(new CustomEvent('cart:actualizado')); } catch (err) {}
        cb && cb(true);
      })
      .catch(function () { avisoError(); cb && cb(false); });
  }

  /* ---------- eventos ---------- */
  botones.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      anadir(function (ok) { if (ok) marcar(b); });
    });
  });
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      anadir(function (ok) { if (ok) marcar(botones[0]); });
    });
  }
  compras.forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      a.classList.add('is-cargando');
      anadir(function (ok) {
        a.classList.remove('is-cargando');
        if (ok) { window.location.href = '/checkout'; }        /* al pago, ya con el libro dentro */
        else { window.location.href = a.getAttribute('href'); } /* plan B: carrito */
      });
    });
  });

  /* ---------- barra fija de móvil ---------- */
  if (barra && acciones && 'IntersectionObserver' in window) {
    if (window.matchMedia('(max-width: 640px)').matches) document.body.classList.add('pr-con-barra');
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var fueraPorArriba = e.boundingClientRect.top < 0;
        if (!e.isIntersecting && fueraPorArriba) { barra.hidden = false; document.body.classList.add('pr-con-barra'); }
        else { barra.hidden = true; }
      });
    }, { rootMargin: '-70px 0px 0px 0px', threshold: 0 }).observe(acciones);
  }
})();
